import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import connect from "react-redux/es/connect/connect";

import {format} from "date-fns-tz";
import * as ptBR from "date-fns/locale/pt-BR";

import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Xrange from 'highcharts/modules/xrange';
import Accessibility from 'highcharts/modules/accessibility';
import AutoclaveCiclosUtilizacaoChart from "./AutoclaveCiclosUtilizacaoChart";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography";
import ComplexGrid from "../../../common/ComplexGrid";
import classNames from "classnames";
import {COLOR_chart_series_first_line} from "../../../common/CustomTheme/ThemeDefault/colors";


HighchartsMore(ReactHighcharts.Highcharts);
Xrange(ReactHighcharts.Highcharts);
Accessibility(ReactHighcharts.Highcharts);


//var Moment = require('moment-timezone');
//require('moment/locale/pt-br');


const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
    progress: {
        margin: theme.spacing(1) * 2,
    },
    mainGrid: {
        // backgroundColor: 'cyan',
        margin: '6px 0px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-around',
        alignItems: 'stretch',
        alignContent: 'stretch'
    },
    marginAuto:{
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
        margin: '8px',
        border: '3px',
        borderColor: 'yellow',
        // display: 'flex',
        //   flexGrow: '0.2',
        // width: '100%',
        //   height: '100%'
    }
}));

interface Custom extends ReactHighcharts.PointOptionsObject {
    autoclaveId: number;
    ciclo: number;
    data: string;
    minutos: number;
    minH: string;
    maxH: string;
}

const ConvertMinutes = (num) => {
    const d = 0; //Math.floor(num/1440); // 60*24
    const h = Math.floor((num-(d*1440))/60);
    const m = Math.round(num%60);

    if(d>0){
        return(d + "d " + h + "h "+m+" min");
    }else{
        return(h + "h"+m+ "m");
    }
}


const AutoclaveUtilizacao = ({
    autoclave,
    dados,
    estabelecimentos,
    estabelecimentoId

}) => {


  const classes = useStyles();

   // console.log("AutoclaveUtilizacao => props dados", dados);

    console.log("ESTABLED ", estabelecimentoId,estabelecimentos);


    const estab = estabelecimentos.find( e => e.id === estabelecimentoId);


    let tCiclos = 0;

    let tCiclosValidos = 0;
    let tUtilizacao = 0;
    let tPercUtilizacao = 0;
    let tOS = 0;
    let tCapacidade = 0;

    let xd;
    let dd = "";
    let iciclo = -1;
    let ciclos = []
    let ser  = []
    let idias = -1;
    let dias = [];

    const maxTempo = estab? estab.minVulcParaCicloAutoclaveValido? estab.minVulcParaCicloAutoclaveValido : 60 : 60;

    console.log("AUTOCLAVE DADOS", dados);

    dados.map((d,ix) => {
        xd = new Date(d.minH);
        dd = xd.toISOString().substring(0,10);
        // console.log("map dias", ix, dd);

        idias = dias.findIndex((di) => di === dd);
        if (idias < 0) {
            dias.push(dd  );

        }

        xd = d.ciclo;

        iciclo = ciclos.findIndex((di) => di === xd);
        if (iciclo < 0) {
            ciclos.push(xd);
            tCiclos = tCiclos + 1;
            tOS = tOS + d.pneus;
            if (d.maxETV > maxTempo) {
                tCiclosValidos += 1;
                tCapacidade = tCapacidade + d.capacidade
            }
            tUtilizacao = tUtilizacao + d.minutos;
            //tOS = tOS + d.pneus;
            //tCapacidade = tCapacidade + d.capacidade
        }
    });
    idias = dias.length;

    const estabelecimento = estabelecimentos.find( (e) => e.id === estabelecimentoId * 1)


   // console.log("serie", ser);
    console.log("estabelecimento",  estabelecimentoId);
    console.log("diasutil ", autoclave.codigo, dias.length);


    return (
        <React.Fragment>
            <Card>
                <Grid container style={{ alignItems:'stretch', height: '100%',  padding: '2px' }}>
                    <Grid container xs={12} className={classes.mainGrid}>
                        <Grid item className={classNames(classes.marginAuto)}>
                            <Typography variant="h5">Autoclave: {autoclave.codigo} -  Modelo: {autoclave.fabricante} - Capacidade: {autoclave.capacidade} pneus</Typography>
                        </Grid>
                    </Grid>
                    <Grid container xs={12} className={classes.mainGrid}>
                        <Grid item className={classNames(classes.marginAuto)}>
                            <ComplexGrid
                                className={classes.marginAuto}
                                leftSideGrid={true}
                                iconState="success"
                                icon="business_money-coins"
                                mainvalue={<span><small></small>
                                   {tCiclos}</span>}
                                title={<span>CICLOS</span>}
                                description={<span>ciclos executados.</span>}
                                unit="un"
                            />
                        </Grid>
                        <Grid item className={classNames(classes.marginAuto)}>
                            <ComplexGrid
                                className={classes.marginAuto}
                                leftSideGrid={true}
                                iconState="success"
                                icon="business_money-coins"
                                mainvalue={<span><small></small>
                                    {tCiclosValidos}</span>}
                                title={<span>CICLOS VÁLIDOS</span>}
                                description={<span>ciclos executados > {maxTempo}min de vulcanização.</span>}
                                unit="un"
                            />
                        </Grid>
                        <Grid item className={classNames(classes.marginAuto)}>
                            <ComplexGrid
                                className={classes.marginAuto}
                                leftSideGrid={true}
                                iconState="success"
                                icon="business_money-coins"
                                mainvalue={<span><small></small>
                                   {ConvertMinutes(tUtilizacao)}</span>}
                                title={<span>UTILIZAÇÃO</span>}
                                description={<span>tempo em ciclo.</span>}
                                unit="hhh:mm"
                            />
                        </Grid>
                        <Grid item className={classNames(classes.marginAuto)}>
                            <ComplexGrid
                                className={classes.marginAuto}
                                leftSideGrid={true}
                                iconState="success"
                                icon="business_money-coins"
                                mainvalue={<span><small></small>
                                    { Math.round((tUtilizacao/60) / (idias*estabelecimento.cargaHorariaDia) * 100)}</span>}
                                title={<span>% UTILIZAÇÃO</span>}
                                description={<span>{idias}d*{estabelecimento.cargaHorariaDia}h={idias*estabelecimento.cargaHorariaDia}h de disponibilidade.</span>}
                                unit="%"
                            />
                        </Grid>
                        <Grid item className={classNames(classes.marginAuto)}>
                            <ComplexGrid
                                className={classes.marginAuto}
                                leftSideGrid={true}
                                iconState="success"
                                icon="business_money-coins"
                                mainvalue={<span><small></small>
                                   {tOS}</span>}
                                title={<span>ORDENS SERVIÇO</span>}
                                description={<span>OSs vulcanizadas.</span>}
                                unit="un"
                            />
                        </Grid>
                        <Grid item className={classNames(classes.marginAuto)}>
                            <ComplexGrid
                                className={classes.marginAuto}
                                leftSideGrid={true}
                                iconState="success"
                                icon="business_money-coins"
                                mainvalue={<span><small></small>
                                   { Math.round(tOS / tCapacidade * 100).toFixed(0)}</span>}
                                title={<span>% CAPACIDADE</span>}
                                description={<span>{tCiclosValidos}*{autoclave.capacidade}={tCiclosValidos*autoclave.capacidade} pneus.</span>}
                                unit="%"
                            />
                        </Grid>
                    </Grid>
                    <Grid item  xs={12} sm={12} md={12} lg={12} xl={12} style={{ alignItems:'stretch', width: '100%', padding: '2px' }}>
                        <AutoclaveCiclosUtilizacaoChart dados={dados}/>
                    </Grid>
                </Grid>
            </Card>
        </React.Fragment>
    );


}

const mapStateToProps = state => {
  return {
      isAuthenticated: state.auth.id !== null,
      estabelecimentos: state.filter.estabelecimentos,
      estabelecimentoId: state.filter.estabelecimentoId

  }
}

export default connect(mapStateToProps, {
})(AutoclaveUtilizacao)
